import http from './helpers/httpInterceptor'

const state = () => ({
    onsiteList: [],
    overtimeList: [],
    bonusList: [],
    listPeriodPayroll: [],
    payrollUser: {},
    updateOnsitePayroll: [],
    updateOvertimePayroll: [],
    updateBonusPayroll: [],
    getAllHoursSelection : [],
    getAllHoursSelectionSingle: [],
    updateStatusPeriod: [],
    listVersionsUpdateOvertime: [],
    detailHistoryUpdateOvertime: [],
    restoreVersionsOT: [],
    listVersionsUpdateOnsite: [],
    detailHistoryUpdateOnsite: [],
    restoreVersionsOnsite: [],
});

// mutations
const mutations = {
    ONSITE_LIST(states, data) {
        states.onsiteList = data;
    },
    OVERTIME_LIST(states, data) {
        states.overtimeList = data
    },
    BONUS_LIST(states, data) {
      states.bonusList = data
    },
    LIST_PERIOD_PAYROLL(states, data){
        states.listPeriodPayroll = data
    },
    USER_PAYROLL(states, data) {
      states.payrollUser = data;
    },
    UPDATE_ONSITE_PAYROLL(states, data) {
      states.updateOnsitePayroll = data
    },
    UPDATE_OVERTIME_PAYROLL(states, data) {
    states.updateOvertimePayroll = data;
    },
    UPDATE_BONUS_PAYROLL(states, data) {
      states.updateBonusPayroll = data
    },
    GET_ALL_HOURS_SELECTION (states, data) {
      states.getAllHoursSelection = data
    },
    GET_ALL_HOURS_SELECTION_SINGLE (states, data) {
      states.getAllHoursSelectionSingle = data
    },
    UPDATE_STATUS_PERIOD ( states, data ) {
      states.updateStatusPeriod = data
    },
    GET_LIST_VERSIONS_UPDATE_OVERTIME (states, data) {
      states.listVersionsUpdateOvertime = data
    },
    GET_DETAIL_HISTORY_UPDATE_OVERTIME (states, data) {
      states.detailHistoryUpdateOvertime = data
    },
    RESTORE_VERSION_OVERTIME (states, data) {
      states.restoreVersionsOT = data
    },
    GET_LIST_VERSIONS_UPDATE_ONSITE (states, data) {
      states.listVersionsUpdateOnsite = data
    },
    GET_DETAIL_HISTORY_UPDATE_ONSITE (states, data) {
      states.detailHistoryUpdateOnsite = data
    },
    RESTORE_VERSION_ONSITE (states, data) {
      states.restoreVersionsOnsite = data
    }
};

// actions
const actions = {
    getListPayrollPeriod({ commit }) {
      return http
        .get("/payroll/filters/periods")
        .then((res) => {
            commit("LIST_PERIOD_PAYROLL", res.data.data);
            return res.data
        })
        .catch((error) => {
            throw (error)
        });
    },
    getOnsiteList({ commit }, payload) {
        return http
            .get("/payroll/onsite-requests" + payload)
            .then((res) => {
                commit("ONSITE_LIST", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },
    getOvertimeList({ commit }, payload) {
        return http
            .get("/payroll/payroll-overtime" + payload)
            .then((res) => {
                commit("OVERTIME_LIST", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },
    getBonusList({ commit }, payload) {
      return http
        .get("/payroll/bonus" + payload)
        .then((res) => {
            commit("BONUS_LIST", res.data);
            return res.data;
        })
        .catch((error) => {
            throw (error)
        });
    },
    getUserPayroll({ commit }, params) {
        return http.get("/payroll/employee"+ `/periodId/${params.periodId}/employee/${params.employmentID}`).then(res => {
          commit("USER_PAYROLL", res.data.data);
          return res.data
        }).catch(error => {
          throw (error)
        })
    },
    updateOnsitePayroll({ commit }, payload) {
        return http
          .put('/payroll/onsite-requests/update-field-onsite', payload)
          .then(res => {
            commit("UPDATE_ONSITE_PAYROLL", res.data);
            return res.data
          })
          .catch(err => {
            throw err
          })
    },
    updateOvertimePayroll({ commit }, payload) {
        return http
          .put('/payroll/payroll-overtime/update-payroll-ot', payload)
          .then(res => {
            commit("UPDATE_OVERTIME_PAYROLL", res.data);
            return res.data
          })
          .catch(err => {
            throw err
          })
    },
    updateBonusPayroll({ commit },payload) {
      return http
          .put('/payroll/bonus/update-other-violation'+`?key=${payload.params}`, payload.payload)
          .then(res => {
            commit("UPDATE_BONUS_PAYROLL", res.data);
            return res.data
          })
          .catch(err => {
            throw err
          })
    },
    getAllHoursSelectionSingle({ commit }, params) {
      return http.get("/payroll/payroll-overtime/get-hours-selection-single"+ `?contractType=${params.contractType}&recordId=${params.recordId}`).then(res => {
        commit("GET_ALL_HOURS_SELECTION_SINGLE", res.data.data);
        return res.data
      }).catch(error => {
        throw (error)
      })
    },
    getAllHoursSelection({ commit }, params) {
      return http.get("/payroll/payroll-overtime/get-all-hours-selection"+ `?contractType=${params.contractType}`).then(res => {
        commit("GET_ALL_HOURS_SELECTION", res.data.data);
        return res.data
      }).catch(error => {
        throw (error)
      })
    },
    updateStatusPeriod({ commit }, payload) {
      return http
        .put('payroll/timesheet/update-status'+ payload)
        .then(res => {
          commit("UPDATE_STATUS_PERIOD", res.data);
          return res.data
        })
        .catch(err => {
          throw err
        })
    },
    getListVersionsUpdateOvertime({commit}, params) {
      return http
        .get("/payroll/payroll-overtime/get-dropdown-list-history" + params)
        .then((res) => {
            commit("GET_LIST_VERSIONS_UPDATE_OVERTIME", res.data);
            return res.data
        })
        .catch((error) => {
            throw (error)
        });
    },
    getDetailHistoryUpdateOvertime({commit}, params) {
      return http
        .get("/payroll/payroll-overtime/get-version-history" + params)
        .then((res) => {
            commit("GET_DETAIL_HISTORY_UPDATE_OVERTIME", res.data);
            return res.data
        })
        .catch((error) => {
            throw (error)
        });
    },
    restoreVersionOvertime({ commit }, payload) {
      return http
        .put('/payroll/payroll-overtime/restore-version', payload)
        .then(res => {
          commit("RESTORE_VERSION_OVERTIME", res.data);
          return res.data
        })
        .catch(err => {
          throw err
        })
    },
    getListVersionsUpdateOnsite({commit}, params) {
      return http
        .get("/payroll/onsite-requests/get-list-onsite-history" + params)
        .then((res) => {
            commit("GET_LIST_VERSIONS_UPDATE_ONSITE", res.data);
            return res.data
        })
        .catch((error) => {
            throw (error)
        });
    },
    getDetailHistoryUpdateOnsite({commit}, params) {
      return http
        .get("/payroll/onsite-requests/get-onsite-history-by-id" + params)
        .then((res) => {
            commit("GET_DETAIL_HISTORY_UPDATE_ONSITE", res.data);
            return res.data
        })
        .catch((error) => {
            throw (error)
        });
    },
    restoreVersionOnsite({ commit }, payload) {
      return http
        .put('/payroll/onsite-requests/revert-version', payload)
        .then(res => {
          commit("RESTORE_VERSION_ONSITE", res.data);
          return res.data
        })
        .catch(err => {
          throw err
        })
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};